

















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
// @ts-ignore
import { quillEditor } from 'vue-quill-editor'

@Component({
  components: {
    quillEditor
  }
})
export default class TodoForm extends Vue {

  editorOption = {
    modules: {
      toolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        ['blockquote', 'code-block'],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      ]
    },
    placeholder: 'Введите текст ...'
  }

  form = {
    body: '',
    todo_type_id: null,
    deadline_at: null,
    responsible_id: null,
  }

  save() {
    this.$emit('save', this.form)
  }

  cancel() {
    this.$emit('cancel')
  }
}

